export function getStrokeLinecapRoundRadius(strokeWidth: number) {
	const strokeLinecapRoundDiameter = strokeWidth;
	const strokeLinecapRoundRadius = strokeLinecapRoundDiameter / 2;

	return strokeLinecapRoundRadius;
}
